import React, { useContext, useMemo, useState } from 'react';
import {
  notification,
  Popconfirm,
  Button as Antdbutton,
  Row,
  Col,
  Tag,
} from 'antd';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { useQuery } from 'react-query';
import {
  AssetCatalogResponse,
  duplicateAssetCatalog,
  getAssetCatalogListByCriteria,
  GetAssetCatalogListByCriteriaParams,
} from 'services/assetconfig';
// import AssetCatalogStatusButton from './components/AssetCatalogStatusButton';
import DuplicateButtonAction from 'components/DuplicatButtonAction';
import { useNavigate } from 'react-router-dom';
import TasksListPopover from 'pages/workflow/TasksListPopover';
import IActions from 'icons/IActions';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { AuthContext } from 'components/Auth/Auth';
import { toCurrency } from 'utils/utils';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Button from 'components/Button';
import { PlusOutlined } from '@ant-design/icons';
import MgCompanyList from 'components/MgCompanyList';

export type ParAssetCatalogSearchModalProps = {
  visible: boolean;
  onCancel: () => void;
  hideAssetCatalogModal?: () => void;
  onAssetSelect: (page: AssetCatalogResponse) => void;
  hideAddButton?: boolean;
  hideActionsButton?: boolean;
  status?:string
};

const AssetCatalogList = (props: ParAssetCatalogSearchModalProps) => {
  const { onAssetSelect, hideAddButton, hideActionsButton,status } = props;
  const [searchs, setsearchs] = useState<boolean>(false);

  const { isInspect } = useContext(AuthContext);

  const initialSearchParams: GetAssetCatalogListByCriteriaParams = {
    catalogid: '' as any,
    category: '',
    assetconstructor: '',
    label: '',
    mcid: 0,
    mgid: Number (localStorage.getItem('mgid'))??0,
    model: '',
    networkcode: '',
    reference: '',
    status: props.status??'',
    tpidbroker: 0,
    tpidsupplier: 0,
    type: '',
    variant: '',
    tpidmanufacturer: 0,
  };


  const [searchParams, setSearchParams] =
    useState<GetAssetCatalogListByCriteriaParams>(initialSearchParams);
  const navigate = useNavigate();
  const [refetchDuplicate, setRefetchDuplicate] = useState(false);

  const [statetype, setStateType] = useState<any>('');
  const { data, isFetching, refetch } = useQuery(
    ['getAssetCatalogListByCriteria', searchParams],
    () =>
      getAssetCatalogListByCriteria(searchParams).then((res) => res.list || []),
    { refetchOnMount: false, enabled: searchs }
  );

  const columns = useMemo<DataGridColDef<AssetCatalogResponse>[]>(
    () => [
      {
        dataIndex: 'catalogid',
        filtrable: true,
        fixed: true,
        render: (_value, _record, index) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              onAssetSelect
                ? onAssetSelect(_record)
                : navigate(
                    `/configuration/asset-catalog/${_record.catalogid}`
                  );
            }}
          >
            {_record.catalogid}
          </a>
        ),
        width: 100,
      },
      {
        dataIndex: 'label',
        filtrable: true,
        fixed: true,
        render: (_value, _record, index) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              onAssetSelect
                ? onAssetSelect(_record)
                : navigate(
                    `/configuration/asset-catalog/${_record.catalogid}`
                  );
            }}
          >
            {_record.assetlabel}
          </a>
        ),
        width: 240,
      },
      {
        dataIndex: 'catalogidlinkedlabel',
        filtrable: true,
        fixed: true,
        render: (_value, _record, index) => (
          <a
            onClick={(e) => {
              e.preventDefault();
              onAssetSelect
                ? onAssetSelect(_record)
                : navigate(
                    `/configuration/asset-catalog/${_record.catalogidlinked}`
                  );
            }}
          >
            {_record.catalogidlinkedlabel}
          </a>
        ),
        width: 240,
      },

      {
        dataIndex: 'type',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="ASSETTYPE"
            onSelect={(e) => {
              setStateType(e);
            }}
          />
        ),
        render: (_value, _record, index) => _record.assettypelabel,
        width: 180,
      },
      {
        dataIndex: 'category',
        filtrable: true,
        filterComponent: (
          <ParListSelect parcode="ASSETCAT" parvalueparent={statetype} />
        ),
        render: (_value, _record, index) => _record.assetcategorylabel,
        width: 180,
      },
      {
        dataIndex: 'tpidmanufacturer',
        filtrable: 'tpidmanufacturer',
        filterComponent: <ThirdPartyInput role="OEM" onlytpid />,
        render: (_value, _record, index) => {
          return _record.manufacturername;
        },
        width: 200,
      },
      {
        dataIndex: 'suppliername',
        filtrable: 'tpidsupplier',
        filterComponent: <ThirdPartyInput role="SUPPLIER" onlytpid />,
        render: (_value, _record, index) => {
          return _record.suppliername;
        },
        width: 240,
      },
      {
        dataIndex: 'brokername',
        filtrable: 'tpidbroker',
        filterComponent: <ThirdPartyInput role="BROKER" onlytpid />,
        render: (_value, _record, index) => {
          return _record.brokername;
        },
        width: 200,
      },
      // {
      //   dataIndex: 'reference',
      //   filtrable: true,
      //   render: (_value, _record, index) => _record.assetconstructorreference,
      //   width: 240,
      // },
      // {
      //   dataIndex: 'assetconstructor',
      //   render: (_value, _record, index) => {
      //     return _record.assetconstructor;
      //   },
      //   width: 160,
      // },
      {
        dataIndex: 'model',
        render: (_value, _record, index) => {
          return _record.assetmodel;
        },
        width: 160,
      },
      {
        dataIndex: 'variant',
        filtrable: true,
        render: (_value, _record, index) => {
          return _record.assetvariant;
        },
        width: 160,
      },
      {
        dataIndex: 'networkcode',
        filtrable: true,
        filterComponent: <ParListSelect parcode="NETWORK" />,
        render: (_value, _record, index) => _record.networkcode,
        width: 180,
      },

      // {
      //   dataIndex: 'tpidbroker',
      //   render: (_value, _record, index) => {
      //     return _record.tpidbroker;
      //   },
      //   width: 140,
      // },
      {
        dataIndex: 'assetnetamount',
        render: (_value, _record, index) =>
          toCurrency(_record.assetnetamount, _record.currcode),
        width: 240,
        fixed: 'right',
      },
      {
        dataIndex: 'mgid',
        filtrable: true,
        filterComponent: <MgCompanyList onChange={(e) => {}} disabled/>,
        width: 70,
      },
      {
        dataIndex: 'status',
        fixed: 'right',
        filtrable: true,
        filterComponent: <ParListSelect parcode="ASCASTATUS" />,
        render: (_value, _record, index) => {
          return (
            <Tag
              color={
                _record.catalogstatus === 'ACTIVE'
                  ? 'success'
                  : _record.catalogstatus === 'DISABLED'
                  ? 'error'
                  : 'default'
              }
            >
              {_record.assetstatuslabel}
            </Tag>
          );
        },
        width: 160,
      },
      
      {
        key: 'actions',
        render: (_, _record) => (
          <Row justify="center">
            <Col>
              <TasksListPopover
                entityId={_record.catalogid}
                entityReference={'ID : ' + _record?.catalogid}
                entityName="CATALOG"
                title={_record.assetlabel}
                onClose={refetch}
              >
                <Antdbutton
                  size="middle"
                  icon={<IActions height="15px" width="15px" />}
                >
                  <GetLabel label="actions" />
                </Antdbutton>
              </TasksListPopover>
            </Col>

            {/* <AssetCatalogStatusButton
              type="primary"
              refetch={refetch}
              catalogid={_record.catalogid}
              status={_record.catalogstatus}
            /> */}

            <Col style={{ marginTop: '3px' }}>
              <Popconfirm
                title="Sure to duplicate?"
                onConfirm={() => {
                  !isInspect &&
                    duplicateAssetCatalog({
                      catalogid: _record.catalogid,
                      catalogidorigine: 0,
                      isnewVersion: false,
                    }).then((res) => {
                      navigate(
                        `/configuration/asset-catalog/${res.data.catalogid}`
                      );
                      notification.success({ message: res.message });
                      //refetch();
                    });
                }}
              >
                <DuplicateButtonAction comcode="duplicate" />
              </Popconfirm>
            </Col>
            <Col style={{ marginTop: '3px' }}>
              <Popconfirm
                title="Sure to create a new version ?"
                onConfirm={() => {
                  !isInspect &&
                    duplicateAssetCatalog({
                      catalogid: _record.catalogid,
                      catalogidorigine:
                        _record.catalogidorigine ?? _record.catalogid,
                      isnewVersion: true,
                    }).then((res) => {
                      navigate(
                        `/configuration/asset-catalog/${res.data.catalogid}`
                      );
                      notification.success({ message: res.message });
                      //refetch();
                    });
                }}
              >
                <DuplicateButtonAction comcode="newVersion" />
              </Popconfirm>
            </Col>
          </Row>
        ),
        width: 180,
        fixed: 'right',
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, refetch, statetype, searchParams, refetchDuplicate, isInspect]
  );

  return (
    <DF.Provider pagcode="assetCatalogList">
      <DataGrid
        dataSource={data}
        columns={
          hideActionsButton
            ? columns.filter((col) => col.key !== 'actions')
            : columns
        }
        componentName="assetCatalog_list"
        titleComcode="assetCatalogList"
        onSearch={(values) => {
          setsearchs(true);
        // setSearchParams(refetchDuplicate ? searchParams : values);
          setSearchParams(values)
        }}
        pagination={{ pageSize: 50 }}
        isLoading={isFetching}
        initialSearchValues={initialSearchParams}
        hideExtraAction={hideAddButton ? true : false}
        rowKey={(record) => record.catalogid}
        extraActions={
          <Button
            onClick={() => {
              !isInspect && navigate(`/configuration/asset-catalog/create`);
            }}
            icon={<PlusOutlined />}
            type="primary"
            comcode="add"
          />
        }
      />
    </DF.Provider>
  );
};

export default AssetCatalogList;
